// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.2.0 (commit eb11e2f5c41dce6979715ad407996270d61329f6).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AdminRenameUserReducer from "./admin_rename_user_reducer";
import BanUserReducer from "./ban_user_reducer";
import DeployTreeReducer from "./deploy_tree_reducer";
import DespawnCharacterReducer from "./despawn_character_reducer";
import EnterWorldReducer from "./enter_world_reducer";
import RerollNameReducer from "./reroll_name_reducer";
import SetUserAdminReducer from "./set_user_admin_reducer";
import SpawnCharacterReducer from "./spawn_character_reducer";
import UnbanUserReducer from "./unban_user_reducer";
import UpdatePoseReducer from "./update_pose_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AdminUserRow from "./admin_user_table";
import CharacterRow from "./character_table";
import CharacterPoseRow from "./character_pose_table";
import OnlineUserRow from "./online_user_table";
import ReducerResultRow from "./reducer_result_table";
import RegionRow from "./region_table";
import SegmentRow from "./segment_table";
import TreeRow from "./tree_table";
import UserRow from "./user_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  adminUser: __table({
    name: 'admin_user',
    indexes: [
      { accessor: 'identity', name: 'admin_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'admin_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, AdminUserRow),
  character: __table({
    name: 'character',
    indexes: [
      { accessor: 'characterId', name: 'character_character_id_idx_btree', algorithm: 'btree', columns: [
        'characterId',
      ] },
      { accessor: 'characterByIdentity', name: 'character_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'characterByRegionId', name: 'character_region_id_idx_btree', algorithm: 'btree', columns: [
        'regionId',
      ] },
      { accessor: 'characterBySegmentId', name: 'character_segment_id_idx_btree', algorithm: 'btree', columns: [
        'segmentId',
      ] },
      { accessor: 'characterByTreeId', name: 'character_tree_id_idx_btree', algorithm: 'btree', columns: [
        'treeId',
      ] },
      { accessor: 'characterByUserId', name: 'character_user_id_idx_btree', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'character_character_id_key', constraint: 'unique', columns: ['characterId'] },
    ],
  }, CharacterRow),
  characterPose: __table({
    name: 'character_pose',
    indexes: [
      { accessor: 'identity', name: 'character_pose_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'characterPoseByRegionId', name: 'character_pose_region_id_idx_btree', algorithm: 'btree', columns: [
        'regionId',
      ] },
      { accessor: 'characterPoseByTreeId', name: 'character_pose_tree_id_idx_btree', algorithm: 'btree', columns: [
        'treeId',
      ] },
    ],
    constraints: [
      { name: 'character_pose_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
    event: true,
  }, CharacterPoseRow),
  onlineUser: __table({
    name: 'online_user',
    indexes: [
      { accessor: 'identity', name: 'online_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'online_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, OnlineUserRow),
  reducerResult: __table({
    name: 'reducer_result',
    indexes: [
      { accessor: 'reducerResultByCorrelationId', name: 'reducer_result_correlation_id_idx_btree', algorithm: 'btree', columns: [
        'correlationId',
      ] },
      { accessor: 'resultId', name: 'reducer_result_result_id_idx_btree', algorithm: 'btree', columns: [
        'resultId',
      ] },
    ],
    constraints: [
      { name: 'reducer_result_result_id_key', constraint: 'unique', columns: ['resultId'] },
    ],
  }, ReducerResultRow),
  region: __table({
    name: 'region',
    indexes: [
      { accessor: 'regionByName', name: 'region_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'regionId', name: 'region_region_id_idx_btree', algorithm: 'btree', columns: [
        'regionId',
      ] },
    ],
    constraints: [
      { name: 'region_region_id_key', constraint: 'unique', columns: ['regionId'] },
    ],
  }, RegionRow),
  segment: __table({
    name: 'segment',
    indexes: [
      { accessor: 'segmentByParentSegmentId', name: 'segment_parent_segment_id_idx_btree', algorithm: 'btree', columns: [
        'parentSegmentId',
      ] },
      { accessor: 'segmentByRegionId', name: 'segment_region_id_idx_btree', algorithm: 'btree', columns: [
        'regionId',
      ] },
      { accessor: 'segmentId', name: 'segment_segment_id_idx_btree', algorithm: 'btree', columns: [
        'segmentId',
      ] },
      { accessor: 'segmentByTreeId', name: 'segment_tree_id_idx_btree', algorithm: 'btree', columns: [
        'treeId',
      ] },
    ],
    constraints: [
      { name: 'segment_segment_id_key', constraint: 'unique', columns: ['segmentId'] },
    ],
  }, SegmentRow),
  tree: __table({
    name: 'tree',
    indexes: [
      { accessor: 'treeByArchetypeId', name: 'tree_archetype_id_idx_btree', algorithm: 'btree', columns: [
        'archetypeId',
      ] },
      { accessor: 'treeByRegionId', name: 'tree_region_id_idx_btree', algorithm: 'btree', columns: [
        'regionId',
      ] },
      { accessor: 'treeId', name: 'tree_tree_id_idx_btree', algorithm: 'btree', columns: [
        'treeId',
      ] },
    ],
    constraints: [
      { name: 'tree_tree_id_key', constraint: 'unique', columns: ['treeId'] },
    ],
  }, TreeRow),
  user: __table({
    name: 'user',
    indexes: [
      { accessor: 'identity', name: 'user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'userByIsAdmin', name: 'user_is_admin_idx_btree', algorithm: 'btree', columns: [
        'isAdmin',
      ] },
      { accessor: 'userByOnline', name: 'user_online_idx_btree', algorithm: 'btree', columns: [
        'online',
      ] },
      { accessor: 'userByUserId', name: 'user_user_id_idx_btree', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, UserRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("admin_rename_user", AdminRenameUserReducer),
  __reducerSchema("ban_user", BanUserReducer),
  __reducerSchema("deploy_tree", DeployTreeReducer),
  __reducerSchema("despawn_character", DespawnCharacterReducer),
  __reducerSchema("enter_world", EnterWorldReducer),
  __reducerSchema("reroll_name", RerollNameReducer),
  __reducerSchema("set_user_admin", SetUserAdminReducer),
  __reducerSchema("spawn_character", SpawnCharacterReducer),
  __reducerSchema("unban_user", UnbanUserReducer),
  __reducerSchema("update_pose", UpdatePoseReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.2.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

